/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/* eslint-disable valid-jsdoc */

import {registerInternalPlugin} from '@webex/webex-core';

import Metrics from './metrics';
import config from './config';
import NewMetrics from './new-metrics';
import * as Utils from './utils';
import * as AutomatedUserUtils from './automated-user';
import {
  ClientEvent,
  ClientEventLeaveReason,
  SubmitBehavioralEvent,
  SubmitClientEvent,
  SubmitInternalEvent,
  SubmitOperationalEvent,
  SubmitBusinessEvent,
  SubmitMQE,
  PreComputedLatencies,
  SubmitFeatureEvent,
  LocusSyncLatencyEventName,
  PrivacyAndSecurityPermission,
} from './metrics.types';
import * as CALL_DIAGNOSTIC_CONFIG from './call-diagnostic/config';
import * as CallDiagnosticUtils from './call-diagnostic/call-diagnostic-metrics.util';
import CallDiagnosticMetrics from './call-diagnostic/call-diagnostic-metrics';
import CallDiagnosticLatencies from './call-diagnostic/call-diagnostic-metrics-latencies';
import BehavioralMetrics from './behavioral-metrics';
import OperationalMetrics from './operational-metrics';
import BusinessMetrics from './business-metrics';
import RtcMetrics from './rtcMetrics';
import PreLoginMetrics from './prelogin-metrics';

registerInternalPlugin('metrics', Metrics, {
  config,
  /**
   * Stops network telemetry before SDK logout.
   * @returns
   */
  onBeforeLogout() {
    return this.stopNetworkTelemetry();
  },
});

registerInternalPlugin('newMetrics', NewMetrics, {
  config,
});

export {default, getOSNameInternal} from './metrics';

export {
  config,
  CALL_DIAGNOSTIC_CONFIG,
  AutomatedUserUtils,
  NewMetrics,
  Utils,
  CallDiagnosticUtils,
  CallDiagnosticLatencies,
  CallDiagnosticMetrics,
  BehavioralMetrics,
  OperationalMetrics,
  BusinessMetrics,
  RtcMetrics,
  PreLoginMetrics,
};
export {isAutomatedUser, isAutomatedUserAgent} from './automated-user';
export type {
  ClientEvent,
  ClientEventLeaveReason,
  SubmitBehavioralEvent,
  SubmitClientEvent,
  SubmitInternalEvent,
  SubmitMQE,
  SubmitOperationalEvent,
  SubmitBusinessEvent,
  PreComputedLatencies,
  SubmitFeatureEvent,
  LocusSyncLatencyEventName,
  PrivacyAndSecurityPermission,
};
